<template>
    <div class="list-option"
         :class="{ 'disabled': disabled, 'selected': selected, 'no-wrap': noWrap, 'centralised': centralise }"
         v-on:click="click">

        <div class="inner flex-v-center">
          <span class="title" :title="mainText">
              {{ mainText }}
          </span>

          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px">
            <g fill="none" fill-rule="evenodd">
              <rect x="5" y="5" width="20" height="20" rx="3"/>
              <polyline points="28 3 15.1266569 17 10 11.8756235"></polyline>
            </g>
          </svg>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'listOption',
      props: [
        'mainText',
        'subText',
        'disabled',
        'noWrap',
        'centralise'
      ],
      data () {
        return {
          'selected': false
        }
      },
      methods: {
        click () {
          if (this.disabled) {
            return
          }

          this.selected = !this.selected

          if (this.selected) {
            this.$emit('selected')
          } else {
            this.$emit('unselected')
          }
        }
      },
      computed: {
      }
    }
</script>



// WEBPACK FOOTER //
// listOption.vue?476ef2a4